import { gql } from "@apollo/client";

export const CREATE_SELLERS = gql`
mutation createSeller(
    $arcimedes_row_id: ID,
    $status: String,
    $agent: String,
    $first_name: String,
    $last_name: String,
    $company_name: String,
    $company_address: String,
    $company_city: String,
    $company_state: String,
    $company_zip: Int,
    $phone: String,
    $email: String,
    $notes: String,
    $profile: String,
    $cell_phone: String,
    $last_modified: String,
    $deleted: Int,
    $arcimedes_created: String,
    $arcimedes_created_by: String,
    $arcimedes_modified: String,
    $arcimedes_modified_by: String,

) {
    createOrUpdateSeller(input: {
        arcimedes_row_id: $arcimedes_row_id,
        status: $status,
        agent: $agent,
        first_name: $first_name,
        last_name: $last_name,
        company_name: $company_name,
        company_address: $company_address,
        company_city: $company_city,
        company_state: $company_state,
        company_zip: $company_zip,
        phone: $phone,
        email: $email,
        notes: $notes,
        profile: $profile,
        cell_phone: $cell_phone,
        last_modified: $last_modified,
        deleted: $deleted,
        arcimedes_created: $arcimedes_created,
        arcimedes_created_by: $arcimedes_created_by,
        arcimedes_modified: $arcimedes_modified,
        arcimedes_modified_by: $arcimedes_modified_by
    }) {
        seller {
            arcimedes_row_id,
            status,
            agent,
            first_name,
            last_name,
            company_name,
            company_address,
            company_city,
            company_state,
            company_zip,
            phone,
            email,
            notes,
            profile,
            cell_phone,
            last_modified,
            deleted,
            arcimedes_created,
            arcimedes_created_by,
            arcimedes_modified,
            arcimedes_modified_by
        }
    }
}
`
export const CREATE_UPDATE_SELLERS = gql`
mutation createOrUpdateSellers($input: [SellerInput]!) {
    createOrUpdateSellers(input: $input) {
        data {
            ARCIMEDES_ROW_ID
      STATUS
      AGENT
      FIRST_NAME
      LAST_NAME
      COMPANY_NAME
      COMPANY_ADDRESS
      COMPANY_CITY
      COMPANY_STATE
      COMPANY_ZIP
      PHONE
      EMAIL
      NOTES
      PROFILE
      CELL_PHONE
      LAST_MODIFIED
      DELETED
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
    }
    error
    message
    success
    }
}`


export const CREATE_UPDATE_PROPERTY  = gql`
mutation createOrUpdateProperty($input: [PropertyInput]) {
  createOrUpdateProperty(input: $input) {
    data {
      arcimedes_row_id
      deleted
      source
      transaction_type
      status
      visible
      featured
      strive_slider
      name
      address
      city
      state
      zip
      latitude
      longitude
      highlights
      media_kit
      type
      sqft
      list_price
      net_operating_income
      vacancy
      capitalization_rate
      sold_price
      down_payment
      close_of_escrow
      listed_date
      seller_fee_percentage
      total_fee
      lease_type
      lease_commencement_date
      lease_expiration_date
      seller_id
      buyer_id
      year_built
      video_url
      close_noi
      proforma_noi
      proforma_base_rent
      proforma_cap_rate
      close_cap_rate
      close_price_per_sqft
      price_per_sqft
      listing_agent_1
      listing_agent_2
      listing_agent_3
      listing_agent_4
      listing_agent_4_firm
      buyer_agent_1
      buyer_agent_2
      buyer_agent_3
      buyer_agent_4
      buyer_agent_4_firm
      listing_agent_1_percent
      listing_agent_2_percent
      listing_agent_3_percent
      listing_agent_4_percent
      buyer_agent_1_percent
      buyer_agent_2_percent
      buyer_agent_3_percent
      buyer_agent_4_percent
      single_tenant_subcategory
      multi_tenant_subcategory
      tenant_id
      market
      rent_per_sqft
      negotiation_price
      potential_fee
      list_fee
      buyside_fee
      negotiation_cap_rate
      category
      hide_financials
      is_proforma_pricing
      date_removed
      negotiation_price_per_sqft
      base_rent
      expiration_no_of_months
      expiration_date
      effective_date
      referral_fee
      hsc_team_member_1
      hsc_team_member_1_percent
      hsc_team_member_1_net_fee
      hsc_team_member_1_net_percent
      hsc_team_member_1_gross_fee
      hsc_team_member_2
      hsc_team_member_2_percent
      hsc_team_member_2_net_fee
      hsc_team_member_2_net_percent
      hsc_team_member_2_gross_fee
      hsc_agreement_file
      loan_commitment_file
      closing_statement_file
      loan_closing_date
      hsc_approved
      hsc_approved_timestamp
      hsc_approved_initials
      hsc_status
      hsc_price
      hsc_listed_date
      hsc_expiration_no_of_months
      hsc_expiration_date
      hsc_fee_percentage
      hsc_total_fee
      hsc_list_fee
      lender_id
      loan_type
      ltv
      loan_amount
      interest_rate
      amortization
      term
      maturity_date
      annual_loan_payment
      cash_flow
      cash_on_cash
      dscr
      prepayment_penalty
      credits_at_closing
      referral
      referral_percent
      noi_percent
      referred_by_id
      referred_by_type
      referral_type
      hsc_financing
      date_created
      apn
      other_financing
      notes
      rep_agreement_file_1
      rep_agreement_file_2
      rep_agreement_file_3
      rep_agreement_file_4
      rep_agreement_file_5
      in_neg_file_1
      in_neg_file_2
      in_neg_file_3
      in_neg_file_4
      in_neg_file_5
      seller_statement_file
      buyer_statement_file
      website_photo_1
      website_photo_2
      website_photo_3
      website_photo_4
      website_photo_5
      created_by
      flagged_date
      under_contract_in_negotiation_since
      property_info_since
      off_market_since
      last_modified_by
      last_modified_date
      uploaded_from
      is_listing
      was_proposal
      estimated_price_type
      sub_category
      units
      proposal_date
      bank_bonus
      bank_bonus_percent
      arcimedes_created
      arcimedes_created_by
      arcimedes_modified
      arcimedes_modified_by
      agent_1_first_name
      agent_1_last_name
      agent_2_first_name
      agent_2_last_name
      agent_3_first_name
      agent_3_last_name
      agent_4_first_name
      agent_4_last_name
      sellers_first_name
      sellers_last_name
      lender_name
    }
    error
    message
    success
  }
}
`